export function containsHttps(url: string): boolean {
  return url.includes('https://');
}
